import React from 'react';
import { WizardActions } from '../../Shared/Styled';
import { SelectList } from '../SelectList';
import { WizardButton } from '../../Shared/Wizard';
import { useThemeContext, WizardContext } from '../../../context';
import { SelectItem } from '../../../types';

export interface SelectionContentProps {
  tabConfigured: boolean;
  items: SelectItem[];
  selected: string;
  projectName: string;
  isPw365Project: boolean;
}

export function SelectionContent({
  tabConfigured,
  items,
  selected,
  projectName,
  isPw365Project,
}: SelectionContentProps): JSX.Element {
  const theme = useThemeContext();
  return (
    <WizardContext.Consumer>
      {({ goto }) => (
        <>
          <SelectList
            items={items}
            selected={selected}
            selectedProperty='value'
          />
          <WizardActions>
            {tabConfigured && (
              <WizardButton
                direction='back'
                label={'Settings'}
                theme={theme}
                onClick={() => goto('tab-settings')}
              />
            )}
            {isPw365Project ? (
              <WizardButton
                direction='forward'
                label={'Default Content'}
                onClick={() => goto('choose-default-route')}
                disabled={projectName.length <= 0}
                theme={theme}
              />
            ) : (
              <WizardButton
                direction='forward'
                label={'Connection'}
                disabled={projectName.length <= 0}
                theme={theme}
              />
            )}
          </WizardActions>
        </>
      )}
    </WizardContext.Consumer>
  );
}
